module.exports = "<ol class=\"breadcrumb text-xs\"> <li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{ active: crumb.active }\"> <a href=\"{{ crumb.route }}\" ng-if=\"!crumb.active && !crumb.hideLink\">{{ crumb.displayName }}</a> <a ng-if=\"!crumb.active && crumb.hideLink\">{{ crumb.displayName }}</a> <span ng-show=crumb.active>{{ crumb.displayName }}</span> </li> </ol>";


//////////////////
// WEBPACK FOOTER
// ./src/layout/ngBreadCrumbTemplate.html
// module id = 1559
// module chunks = 0